export default {
  root: ({ props }) => ({
    class: [
      //Font
      'text-[13px] font-semibold relative pl-5',

      //Alignments
      'inline-flex items-center justify-center',

      //Spacing
      'px-2 h-7',

      //Shape
      {
        'rounded-md': !props.rounded,
        'rounded-full': props.rounded
      },

      //Colors
      'border-0',
      {
        'bg-primary-500 dark:bg-primary-400': props.severity == null || props.severity == 'primary',
        'text-surface-700 dark:text-surface-300 bg-surface-100 dark:bg-surface-500/20': props.severity === 'secondary',
        'bg-gradient-to-b from-green-50 to-green-100 text-green-500 dark:bg-green-400 border-green-200':
          props.severity == 'success',
        'bg-gradient-to-b from-sky-50 to-sky-100 text-sky-500 dark:bg-sky-400':
          props.severity == 'info',
        'bg-yellow-200 dark:bg-yellow-400': props.severity == 'warning',
        'bg-gradient-to-b from-red-50 to-red-100 text-red-500 dark:bg-red-400 border-red-200':
          props.severity == 'danger'
      }
    ]
  }),
  value: {
    class: 'leading-normal'
  },
  icon: {
    class: 'mr-1 text-sm'
  }
}
